import { Alert, Badge } from "react-bootstrap";
// import BadgeEstados from "../BadgeEstado";
import { useActaDetalleStore } from "../../../../store/actaDetalleStore";
import { format } from 'date-fns';

const InfoActa = () => {



    const { actaDetalle, alertas, alertasBloqueo, alertasNoBloqueo } = useActaDetalleStore();

    const { acta, archivos, recibo } = actaDetalle;

    const emailsCortesia = acta?.emails_cortesia
        ?.filter((email) => email.estado_id == 3)
        .sort((a, b) => new Date(b.fecha_enviado) - new Date(a.fecha_enviado)) || null;

    return (
        <div className=" row">
            <section className="col">

                {/* //^ INFO DEL ACTA*/}
                <div className="">
                    <h6 className="m-0 ps-2 pe-5 mb-2 text-light bg-primary py-1" style={{ borderBottom: "1px solid gray", width: "fit-content", lineHeight: "14px" }}>Información del Acta</h6>
                    <div className="d-flex flex-column gap-2">
                        <p className="text-primary  fw-bold m-0" style={{ fontSize: "14px" }}>Tipo Acta: <Badge style={{ verticalAlign: "middle" }} bg={acta.tipo_acta_generada == "DIGITAL" ? "success" : 'primary'}>{acta.tipo_acta_generada}</Badge></p>
                        <p className="text-primary  fw-bold m-0" style={{ fontSize: "14px" }}>Fecha y hora: <span style={{ fontSize: "14px" }} className=" fw-medium text-dark">{acta.fecha_hora}</span></p>
                        <p className="text-primary  fw-bold m-0" style={{ fontSize: "14px" }}>Tipo infracción: <span style={{ fontSize: "14px" }} className=" fw-medium text-dark">{acta.tipo}</span></p>
                        <p className="text-primary  fw-bold m-0" style={{ fontSize: "14px" }}>Dirección: <span style={{ fontSize: "14px" }} className=" fw-medium text-dark">{acta.direccion}</span></p>
                        {
                            emailsCortesia?.length > 0 &&
                            <p className="text-primary fw-bold m-0" style={{ fontSize: "14px" }}>Fecha email cortesia: <span className=" fw-medium text-dark" style={{ fontSize: "14px" }}>{emailsCortesia[0].fecha_enviado}</span></p>
                        }
                        {
                            acta.tipo_acta_generada == "FISICA" &&
                            <>
                                {
                                    (acta.estado_id != 3 && acta.estado_id != 10 && acta.estado_id != 7) &&
                                    <p className="text-primary  fw-bold m-0" style={{ fontSize: "14px" }}>Fecha de impresión: <span className={`${!acta.fecha_impresion ? `text-danger` : 'text-dark'} fw-medium `} style={{ fontSize: "14px" }}>{format(new Date(acta.fecha_impresion), "dd/MM/yyyy HH:mm") || 'No tiene'}</span></p>
                                }
                            </>
                        }
                    </div>
                </div>
            </section >

            <section className={`col d-flex flex-column ${acta.estado_id != 7 && "gap-2"}`} style={{ borderLeft: "2px solid #C7C8C9" }}>
                <>
                    {
                        (acta.estado_id != 2 && acta.estado_id != 3 && acta.estado_id != 7 && acta.estado_id != 10) &&
                        <div className="">
                            {/* //^ INFO DE NOTIFICACION*/}
                            <h6 className="m-0 ps-2 pe-5 mb-2 text-light bg-primary py-1" style={{ borderBottom: "1px solid gray", width: "fit-content", lineHeight: "14px" }}>Información de notificado</h6>
                            <div className="d-flex flex-column gap-2">

                                <p className="m-0 text-primary fw-bold" style={{ fontSize: "14px" }}>Notificador:
                                    {
                                        acta.notificador
                                            ? <span className={`fw-medium text-dark `} style={{ fontSize: "14px" }}>{acta?.notificador?.persona.nombre}</span>
                                            : acta.tipo_acta_generada == "DIGITAL"
                                                ?
                                                <Badge style={{ verticalAlign: "middle" }}>Mi muni digital</Badge>
                                                // <span className={`fw-bold text-dark `} style={{ fontSize: "14px" }}>MI MUNI</span>
                                                : <span className={`fw-medium text-danger `} style={{ fontSize: "14px" }}>No tiene</span>
                                    }
                                </p>
                                {
                                    acta?.notificador &&
                                    <p className="m-0 text-primary  fw-bold" style={{ fontSize: "14px" }}>Fecha asignado: <span className="fw-medium text-dark" style={{ fontSize: "14px" }}>{format(new Date(acta.notificador.fecha_asignado), "dd/MM/yyyy HH:mm")}</span></p>
                                }
                            </div>
                        </div>
                    }
                </>

                <>
                    {
                        (acta.estado_id != 3 && acta.estado_id != 10 && acta.estado_id != 2 && acta.estado_id != 7 && acta.estado_id != 8 && acta.estado_id != 9 && acta.estado_id != 10) &&
                        <div >
                            {/* <h5 className="fw-bold text-primary mb-2 pe-5" style={{ borderBottom: "1px solid gray", width: "fit-content" }}>Notificación</h5> */}
                            <div className="d-flex flex-column gap-2">
                                <p className="m-0 text-primary  fw-bold" style={{ fontSize: "14px" }}>Fecha notificación: <span className={`${!acta.fecha_notificacion ? `text-danger` : "text-dark"} fw-medium `} style={{ fontSize: "14px" }}>{format(new Date(acta.fecha_notificacion), "dd/MM/yyyy HH:mm") || 'No tiene'}</span></p>
                                {
                                    acta.fecha_notificacion &&
                                    <p className="m-0 text-primary  fw-bold " style={{ fontSize: "14px" }}>Vto. prejudicial: <span className="fw-medium text-dark" style={{ fontSize: "14px" }}>{format(new Date(acta.fecha_vto_prejudicial), "dd/MM/yyyy HH:mm")}</span></p>
                                }
                            </div>
                        </div>
                    }
                </>

                <div>

                </div>

                {
                    (acta.estado_id == 3 || acta.estado_id == 7) && <>
                        {
                            alertas.length > 0 &&
                            <>
                                <h6 className="m-0 ps-2 pe-5 mb-2 text-light bg-danger py-1" style={{ borderBottom: "1px solid gray", width: "fit-content", lineHeight: "14px" }}>Alertas</h6>

                                <div className="d-flex gap-2 align-items-start">
                                    {
                                        alertasBloqueo.length > 0 &&
                                        <div className="border border-1 border-danger rounded py-2 px-4" style={{ width: "fit-content" }}>
                                            <p className="m-0 fw-bold" style={{ fontSize: "14px" }}>Campos necesarios para aprobar el acta</p>
                                            <ul>
                                                {
                                                    alertasBloqueo.map((alerta) => (
                                                        <li className="text-danger fw-medium" key={alerta.id} style={{ fontSize: "14px" }}>{alerta.descripcion}</li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    }
                                    {
                                        alertasNoBloqueo.length > 0 &&
                                        <div className="border border-1 border-danger rounded py-2 px-4" style={{ width: "fit-content" }}>
                                            <p className="m-0 fw-bold" style={{ fontSize: "14px" }}>Campos opcionales para aprobar el acta</p>
                                            <ul>
                                                {
                                                    alertasNoBloqueo.map((alerta) => (
                                                        <li className="text-danger fw-medium" key={alerta.id} style={{ fontSize: "14px" }}>{alerta.descripcion}</li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    }
                                </div>
                            </>}
                    </>
                }
                {/* {
                        acta.estado_id == 7 &&
                        <div className="pt-4">
                            <Alert variant="info">
                                <p className="m-0">Al <span className="fw-bold ">COMPLETAR</span> el acta, pasara al estado <span className="fw-bold">APROBADO</span> automaticamente. Verifique los datos antes de completar el acta</p>

                            </Alert>
                        </div>
                    } */}

            </section>



            {
                (acta.estado_id == 13 || acta.estado_id == 11 || acta.estado_id == 9) &&
                <section className="col" style={{ borderLeft: "2px solid #C7C8C9" }}>
                    {
                        acta.estado_id == 13 &&
                        <div className="">
                            <h6 className="m-0 ps-2 pe-5 mb-2 text-light bg-dark py-1" style={{ borderBottom: "1px solid gray", width: "fit-content", lineHeight: "14px" }}>Información de Descargo</h6>
                            <div className="d-flex  flex-column gap-2">
                                <p className="text-primary  fw-bold m-0" style={{ fontSize: "14px" }}>Fecha descargo: <span style={{ fontSize: "14px" }} className=" fw-medium text-dark">{acta.fecha_descargo}</span></p>
                                <div className=" px-2 pb-3 pt-2 border border-1 border-secondary rounded">
                                    <h6 className="m-0" style={{ fontSize: "14px" }}>Observación: </h6>
                                    <hr className="m-0 mb-1" />
                                    {acta.observacion_descargo ? <p className="m-0 fw-medium" style={{ fontSize: "14px" }}>{acta.observacion_descargo}</p> : <p className="m-0 text-danger fw-medium">No tiene observación.</p>}
                                </div>
                            </div>
                        </div>
                    }
                    {
                        acta.estado_id == 11 &&
                        <div className="">
                            <h6 className="m-0 ps-2 pe-5 mb-2 text-light bg-success py-1" style={{ borderBottom: "1px solid gray", width: "fit-content", lineHeight: "14px" }}>Información de Abonado</h6>
                            <div className="d-flex  flex-column gap-2">
                                <p className="text-primary  fw-bold m-0" style={{ fontSize: "14px" }}>Fecha pago: <span style={{ fontSize: "14px" }} className=" fw-medium text-dark">{recibo?.fecha_pago}</span></p>
                                <p className="m-0 text-primary  fw-bold" style={{ fontSize: "14px" }}>Es voluntario: {acta.is_voluntario ? <Badge bg="success" style={{ verticalAlign: "middle" }}>SI</Badge> : <Badge bg="danger">NO</Badge>}</p>
                            </div>
                        </div>
                    }
                    {
                        acta.estado_id == 9 &&
                        <div className="">
                            <h6 className="m-0 ps-2 pe-5 mb-2 text-dark bg-warning py-1" style={{ borderBottom: "1px solid gray", width: "fit-content", lineHeight: "14px" }}>Motivo no notificado</h6>
                            <div className="d-flex  flex-column gap-2">
                                <p className={`text-primary  fw-bold m-0`} style={{ fontSize: "14px" }}>Motivo: <span style={{ fontSize: "14px" }} className={`${acta?.motivo_no_notificado[0]?.length == 0 ? `text-danger` : "text-dark"} fw-medium `}>{acta?.motivo_no_notificado[0] ? <Badge style={{ verticalAlign: "middle" }} bg="danger">{acta?.motivo_no_notificado[0]?.motivo}</Badge> : 'No tiene motivo'}</span></p>
                                <p className="m-0 text-primary  fw-bold" style={{ fontSize: "14px" }}>Fecha reporte: <span className={`${acta?.motivo_no_notificado[0]?.length == 0 ? `text-danger` : "text-dark"} fw-medium `} style={{ fontSize: "14px" }}>{acta?.motivo_no_notificado[0] ? format(new Date(acta?.motivo_no_notificado[0]?.created_at), 'dd/MM/yyyy HH:mm') : 'No tiene fecha'}</span></p>
                            </div>
                        </div>
                    }
                    {/* {
                        acta.estado_id == 9 &&
                        <div className="  d-flex flex-column ">
                            <h5 className="m-0 mb-3 pe-5" style={{ borderBottom: "1px solid gray", width: "fit-content" }}>Motivo no notificado</h5>
                            <div className="d-flex flex-column">
                                < div className="d-flex flex-column gap-2 ">
                                    <p className="m-0 text-primary  fw-bold" style={{ fontSize: "14px" }}>Motivo: <span className={`${acta?.motivo_no_notificado[0].length == 0 ? `text-danger` : "text-dark"} fw-medium `} style={{ fontSize: "14px" }}>{acta?.motivo_no_notificado[0] ? <Badge bg="danger">{acta?.motivo_no_notificado[0]?.motivo}</Badge> : 'No tiene motivo'}</span></p>
                                    <p className="m-0 text-primary fw-bold" style={{ fontSize: "14px" }}>Fecha reporte: <span className={`${acta?.motivo_no_notificado[0].length == 0 ? `text-danger` : "text-dark"} fw-medium `} style={{ fontSize: "14px" }}>{acta?.motivo_no_notificado[0] ? format(new Date(acta?.motivo_no_notificado[0]?.created_at), 'yyyy-MM-dd HH:mm:ss') : 'No tiene fecha'}</span></p>
                                </div>
                            </div>


                        </div>
                    } */}

                </section>
            }

            {
                acta.estado_id == 12 &&
                <section className="col" style={{ borderLeft: "2px solid #C7C8C9" }}>
                    <div className="">
                        <h6 className="m-0 ps-2 pe-5 mb-2 text-light bg-danger py-1" style={{ borderBottom: "1px solid gray", width: "fit-content", lineHeight: "14px" }}>Motivo anulación</h6>
                        <div className="d-flex  flex-column gap-2">
                            <p className="text-primary  fw-bold m-0" style={{ fontSize: "14px" }}>Motivo: <Badge bg={`danger`} style={{ verticalAlign: "middle" }} size={"lg"}>{acta?.motivo?.estado?.nombre ? acta?.motivo?.estado?.nombre : "No tiene motivo de anulación"}</Badge></p>
                            <p className="text-primary  fw-bold m-0" style={{ fontSize: "14px" }}>Fecha de anulación: <span className="m-0 fw-medium text-dark" style={{ fontSize: "14px" }}>{format(new Date(acta?.motivo?.created_at), "dd/MM/yyyy HH:mm") || "No tiene"}</span></p>
                        </div>
                    </div>

                </section>
            }


        </div >
    );
}
export default InfoActa;